// ABOUTME: A polite live region, hidden on screen, that fills in just after it mounts so a screen reader announces the text.
// ABOUTME: Many screen readers skip a live region that already holds its text when it is inserted, so the text arrives a beat later.

import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { visuallyHidden } from '../../runner/visuallyHidden';

const ANNOUNCE_DELAY_MS = 150;

export default function ArrivalStatus({ text }: { text: string }) {
  const [announced, setAnnounced] = useState('');
  useEffect(() => {
    const id = setTimeout(() => setAnnounced(text), ANNOUNCE_DELAY_MS);
    return () => clearTimeout(id);
  }, [text]);
  return <Box role="status" sx={visuallyHidden}>{announced}</Box>;
}
